<ph-icon [name]="icon()" width="24px" height="24px" />
